import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";   // 👈 importa tu Layout
import Login from "./pages/Login";
import PrivateRoutes from "./components/PrivateRoutes";

function App() {
  return (

    <Routes>
      <Route path="/" element={<Login />} />

      <Route path="/*" element={
        <PrivateRoutes>
          <Layout />
        </PrivateRoutes>
      } />
    </Routes>
  );
}

export default App;
